import React from 'react';
import ReactGA from 'react-ga4';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { GA_TRACKING_NUMBER_PLEBICOM } from '../../constants';

import { enableAnalytics, disableAnalytics } from '../../services/google/analytics/actions';

class AnalyticsComponent extends React.Component {
    componentDidUpdate(prevProps) {
        const { history, enable, isInitialized, enableAnalytics, disableAnalytics } = this.props;

        if (enable) {
            if (!isInitialized) {
                ReactGA.initialize([
                    {
                        trackingId: GA_TRACKING_NUMBER_PLEBICOM,
                        gaOptions: {
                            cookieExpires: 15768000 // 6 mois en secondes
                        }
                    }
                ]);
                enableAnalytics();
            }

            const path = history.location.pathname + history.location.hash;
            ReactGA.send({
                hitType: 'pageview',
                page: path
            });
        } else {
            if (isInitialized) {
                disableAnalytics();
            }
            this.deleteAnalyticsCookies();
        }
    }

    deleteAnalyticsCookies() {
        document.cookie = '_gat=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        document.cookie = '_ga=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        document.cookie = '_gid=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    }

    render() {
        return null;
    }
}

const mapStateToProps = state => {
    return {
        isInitialized: state.google.analytics.enabled
    };
};

const mapDispatchtoProps = {
    enableAnalytics,
    disableAnalytics
};

export default withRouter(connect(mapStateToProps, mapDispatchtoProps)(AnalyticsComponent));



// WEBPACK FOOTER //
// ./src/components/google/AnalyticsComponent.js